/** @format */
import createMutation from "../create-mutation";

//create job
export const useCreateJob = createMutation({
  url: "/job",
  method: "POST",
});

//delete job by id
export const useDeleteJobByID = createMutation({
  url: (job_id) => `/job/${job_id}`,
  method: "DELETE",
});

//update job by id
export const useUpdateJobByID = createMutation({
  url: (job_id) => `/job/${job_id}`,
  method: "PATCH",
});

//create job question
export const useCreateJobQuestion = createMutation({
  url: "/job/question",
  method: "POST",
});

//delete job questions by id
export const useDeleteJobQuestionByID = createMutation({
  url: (question_id) => `/job/question/${question_id}`,
  method: "DELETE",
});

export const useUpdateJobQuestion = createMutation({
  url: (question_id) => `/job/question/${question_id}`,
  method: "PATCH",
});
